import * as React from 'react';
import AdjustmentLevelForm from "../../components/AdjustmentLevels/AdjustmentLevelForm/AdjustmentLevelForm";
var AdjustmentLevel = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u043E \u043D\u0438\u0432\u043E \u043D\u0430 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(AdjustmentLevelForm, null))))));
};
export default AdjustmentLevel;



//////////////////
// WEBPACK FOOTER
// ./src/views/AdjustmentLevels/AdjustmentLevel.tsx
// module id = 286
// module chunks = 0